import { onboardingPlanData } from "../../../../../assets/utils/data/onboarding";
import { LittleSubHeadline, LittleText, MediumText, NotificationText } from "../../../../../components/typography";
import { PlanCard } from "../../../../auth/onboarding/steps/plan-step";
import { Block } from "../../../main";
import doneIcon from '../../../../../assets/images/icons/done-dark-icon.svg';
import { Button } from "../../../../../components/ui/button";
import { COLORS } from "../../../../../assets/utils/enums/colors";
import styled from "styled-components";
import { StructureVisibleSwitch } from "../../../../../components/ui/switch";
import { useState } from "react";
import ModalWindow from "../../../../../components/ui/modal-window";
import { ActionsEnum } from "../../../../../assets/utils/enums/settings";
import cancelIcon from '../../../../../assets/images/icons/minus-circle-icon.svg';
import { useNavigate } from "react-router-dom";

export default function PlanItemPaymentTab() {
    const navigate = useNavigate();
    const [autoContinue, setAutoContinue] = useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [currentActionModal, setCurrentActionModal] = useState<ActionsEnum | null>(null);
    const plan = onboardingPlanData.find(x => x.title === "Pro") ?? onboardingPlanData[2];

    return (
        <PlanBlock className="d-flex flex-column">
            <MainPlanBlock>
                <PlanCard
                    $active={true}
                    className="gap-4 justify-content-between"
                // onClick={() => setPlan(item.title as OnboardingPlanEnum)}
                >
                    <span className="d-flex flex-column">
                        <LittleSubHeadline>{plan.title}</LittleSubHeadline>
                        <LittleText>{plan.description}</LittleText>
                    </span>

                    <span className="d-flex flex-column gap-3">
                        {plan.items.map((text, index) => (
                            <span key={index} className="d-flex align-items-start gap-2">
                                <img src={doneIcon} alt="done-icon" />
                                <NotificationText>{text}</NotificationText>
                            </span>
                        ))}
                    </span>
                    <Button
                        bgcolor={"transparent"}
                        txtcolor={`${COLORS.blue} !important`}
                        brcolor={COLORS.blue}
                        width="auto"
                        brradius="24px"
                        type="small"
                        onClick={() => navigate("/plans")}
                    >
                        <LittleSubHeadline>Змінити тариф</LittleSubHeadline>
                    </Button>
                </PlanCard>
                <div data-type="body">
                    <span>
                        <LittleSubHeadline>Команда:</LittleSubHeadline>
                        <LittleSubHeadline>Clentyra</LittleSubHeadline>
                    </span>
                    <span>
                        <LittleSubHeadline>Статус підписки:</LittleSubHeadline>
                        <Button
                            bgcolor={COLORS.main1}
                            txtcolor={COLORS.white}
                            brcolor={COLORS.main1}
                            width="auto"
                            brradius="12px"
                            $disableInteraction
                            // className="py-1"
                            type="small"
                            onClick={() => { }}
                        >
                            <NotificationText>Активний</NotificationText>
                        </Button>
                    </span>
                    <span>
                        <LittleSubHeadline>Підписка активна до:</LittleSubHeadline>
                        <LittleSubHeadline>24 травня</LittleSubHeadline>
                    </span>
                    <span>
                        <LittleSubHeadline>Дата останньої оплати:</LittleSubHeadline>
                        <LittleSubHeadline>24 квітня</LittleSubHeadline>
                    </span>
                    <span>
                        <div className="d-flex flex-column gap-1"><LittleSubHeadline>Автоматичне продовження:</LittleSubHeadline>
                            <LittleSubHeadline>Після завершення поточного періоду підписка автоматично продовжиться, а оплата буде списана з прив’язаної картки.</LittleSubHeadline>
                        </div>
                        <StructureVisibleSwitch checked={autoContinue} setChecked={() => {
                            setCurrentActionModal(
                                autoContinue
                                    ? ActionsEnum.OFF_AUTOCONTINUE
                                    : ActionsEnum.ON_AUTOCONTINUE
                            );
                            setIsModalOpen(true);
                        }} />
                    </span>
                    <span>
                        <LittleSubHeadline>Сума наступного платежу:</LittleSubHeadline>
                        <LittleSubHeadline>499 ₴</LittleSubHeadline>
                    </span>
                </div>
            </MainPlanBlock>
            <div className="d-flex w-100 gap-3 justify-content-between align-items-center" data-type="additional-div">
                <span className="fw-normal d-flex flex-column flex-wrap w-auto row-gap-1">
                    <LittleText>Хочете більше можливостей?</LittleText>
                    <LittleText>Перейдіть на <span className="fw-bold accent-text">Business</span> і отримайте необмежені можливості.</LittleText>
                </span>
                <Button
                    bgcolor={"transparent"}
                    txtcolor={COLORS.blue}
                    brcolor={COLORS.blue}
                    width="auto"
                    brradius="24px"
                    type="small"
                    onClick={() => navigate("/plans")}
                >
                    <NotificationText>Переглянути всі плани</NotificationText>
                </Button>
            </div>
            <Block
                className={`w-100 d-flex align-items-center justify-content-between`}
            >
                <Button
                    bgcolor={"transparent"}
                    txtcolor={COLORS.secondary1}
                    brcolor={"transparent"}
                    type="large"
                    width="auto"
                    $disableInteraction
                    className="d-flex align-items-center gap-2 text"
                >
                    <img src={cancelIcon} alt="cancel-icon" />
                    <MediumText>Скасувати підписку</MediumText>
                </Button>
                <Button
                    bgcolor={COLORS.warning}
                    txtcolor={COLORS.white}
                    brcolor={"transparent"}
                    type="small"
                    width="auto"
                    brradius="12px"
                    className="d-flex align-items-center gap-2"
                    onClick={() => {
                        setCurrentActionModal(ActionsEnum.CANCEL_SUBSCRIPTION);
                        setIsModalOpen(true);
                    }}
                >
                    <NotificationText>Скасувати підписку</NotificationText>
                </Button>
            </Block>
            <ModalWindow
                isOpen={isModalOpen}
                action={currentActionModal!}
                onConfirm={() => {
                    if (currentActionModal === ActionsEnum.ON_AUTOCONTINUE) {
                        setAutoContinue(true);
                    }

                    if (currentActionModal === ActionsEnum.OFF_AUTOCONTINUE) {
                        setAutoContinue(false);
                    }

                    if (currentActionModal === ActionsEnum.CANCEL_SUBSCRIPTION) {
                        // cancel subscription
                    }

                    setTimeout(() => {
                        setIsModalOpen(false);
                        setCurrentActionModal(null);
                    }, 150);
                }}

                onCancel={() => {
                    setTimeout(() => {
                        setIsModalOpen(false);
                        setCurrentActionModal(null);
                    }, 150);
                }}
                customText={<>Доступ до функцій тарифу збережеться до <u className="accent-text">24 травня</u>.
                    Після цього ваш робочий простір буде переведено на безкоштовний тариф з обмеженим функціоналом. Ви можете поновити підписку у будь-який момент.</>}
            />
        </PlanBlock >
    )
}

const PlanBlock = styled.div`
width: 100%;
 [data-type="additional-div"] {
        padding: 16px 8px;

        ${LittleText} {
            color: ${COLORS.secondary1};
        }
    }
div {
   
}
`

const MainPlanBlock = styled.div`
width: 100%;
    padding: 12px 8px 4px 8px;
border-radius: 16px;
display: flex;
border: 1px solid ${COLORS["light-bg-color"]};
margin-top: 16px;
    background-color: ${COLORS.gray};
    ${PlanCard} {
       border: 1px solid ${COLORS["light-bg-color"]};

    }
    div {
        &[data-type="body"] {
            width: 65%;
            padding: 16px;
            span {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 8px 0;
${LittleSubHeadline} {
    color: ${COLORS.secondary1};
    white-space: break-spaces;
    &:last-of-type {
        font-weight: 400;
    }
    &:first-of-type {
        font-weight: 650;
    }
}
${Button} {
    padding: 4px 12px;
    margin: 0;
}
            }
        }
    }
`